module.exports = __webpack_public_path__ + "static/media/5.f0df3154.jpg";